import * as bootstrap from 'bootstrap';
import Swiper from 'swiper/bundle';
import Helper from './helper';
import 'fslightbox';

import 'swiper/css/bundle';

import.meta.glob([
    '../img/**'
]);

class App {
    constructor() {
        this.init();
    }

    init() {
        this.articleCarousel();
        this.honeyForms();
        this.cookies();
        this.map();
        this.popup();
        this.scrollIntoView();
        this.fontSizeControls();
    }

    articleCarousel() {
        document.querySelectorAll('.articles-slider__list').forEach(element => {
            let paginationOptions = {}, pagination = element.closest('.articles-slider__list').querySelector('.swiper-pagination');

            if (pagination) {
                // Create pagination
                paginationOptions = {
                    clickable 	: true,
                    type        : 'bullets',
                    el			: '#' + pagination.getAttribute('id')
                };
            }

            new Swiper('#' + element.getAttribute('id'), {
                touchStartPreventDefault: true,
                autoplay: false,
                breakpoints: {
                    0: {
                        allowTouchMove: true,
                        loop: true,
                        slidesPerView: 1,
                        spaceBetween: 15
                    },
                    576: {
                        allowTouchMove: false,
                        loop: false,
                        slidesPerView: 2,
                        spaceBetween: 15
                    },
                    992: {
                        spaceBetween: 0,
                    },
                    1400: {
                        spaceBetween: 0,
                        slidesPerView: 'auto'
                    }
                },
                slidesPerGroup: 1,
                // pagination: paginationOptions
            });
        });
    }

    /**
     * Honey pot protection for forms
     */
    honeyForms() {
        document.querySelectorAll('.form--honey').forEach(form => {
            setTimeout(() => {
                let buttonSubmit = form.querySelector('button[type="submit"]');

                if (buttonSubmit) {
                    // Restore original button text
                    buttonSubmit.innerHTML = buttonSubmit.getAttribute('data-text');

                    // Enable the submit button
                    buttonSubmit.disabled = false;
                }

                let coffeeCup = form.querySelector('input[name="coffee_cup"]');

                if (coffeeCup) {
                    // Fill the coffee cup
                    coffeeCup.value = 'filled';
                }
            }, 5000);
        });
    }

    /**
     * Set cookie preferences
     */
    cookies() {
        let form = document.getElementById('form-cookies');

        if (form === null) {
            return false;
        }

        // Show the cookie form
        form.classList.remove('fade');

        // Add cookie selection state
        document.body.classList.add('cookie-selection');

        let options = form.querySelector('.cookies-banner__options');

        let textChecked   = 'Alle cookies accepteren';
        let textUnchecked = 'Geselecteerde cookies accepteren'

        let buttonSubmit = form.querySelector('button[type="submit"]');

        let isAllCookiesChecked = function () {
            let checked = true;

            options.querySelectorAll('.form-check-input').forEach(switchElement => {
                if (switchElement.checked === false) {
                    checked = false;
                }
            });

            return checked;
        }

        options.querySelectorAll('.form-check-input').forEach(input => {
            // Bind the change event listener to the form check input
            input.addEventListener('change', function () {
                buttonSubmit.innerText = isAllCookiesChecked() ? textChecked : textUnchecked;
            });

            // Manually create on on-change event
            let event = new Event('change');

            // Manually dispatch event
            input.dispatchEvent(event);
        });

        const collapseCookies = document.getElementById('collapse-cookies');

        collapseCookies.addEventListener('show.bs.collapse', () => {
            collapseCookies.querySelectorAll('.form-check-input:not(#cookies-functional)').forEach(input => {
                input.checked = false;
            });

            buttonSubmit.innerText = textUnchecked;
        })

        form.addEventListener('submit', function(e) {
            e.preventDefault();

            let formData = new FormData(this);

            if (e.submitter) {
                // Manually add button name and value
                formData.append(e.submitter.name, e.submitter.value);
            }

            Helper.post(this.action, formData).then(() => {
                // Remove cookie selection state
                document.body.classList.remove('cookie-selection');

                // Fade out the form
                form.classList.add('fade');

                setTimeout(function () {
                    // Reload page
                    location.reload();
                }, 1000);
            })
            .catch(error => {
                // Reject the promise
                return Promise.reject(error.statusText);
            });
        });
    }

    popup() {
        let popupEl = document.getElementById('popup');

        if (popupEl === null) {
            return;
        }

        document.querySelectorAll('[data-toggle="popup"]').forEach(element => {
            element.addEventListener('click', (e) => {
                e.preventDefault();

                popupEl.querySelector('.modal-title').innerText = element.dataset.title;
                popupEl.querySelector('.modal-text').innerHTML = element.dataset.content;

                bootstrap.Modal.getOrCreateInstance(popupEl).show();
            });
        });
    }

    map () {
        let container = document.getElementById('map');

        if (container === null) {
            return;
        }

        let osm = L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
            minZoom: 4,
            maxZoom: 20
        });

        let map = new L.Map('map', {
            center: new L.LatLng(52.21967936068696, 6.58498521152085),
            scrollWheelZoom: false,
            zoom: 13
        });

        let icon = L.icon({
            iconUrl: container.dataset.urlMarker,
            iconSize: [55, 68],
        })

        L.marker([52.23667936068696, 6.58498521152085])
            .setIcon(icon)
            .addTo(map)
            .bindPopup('Herfstzon Goor<br />Javastraat 2<br/>7471 RG Goor');

        L.marker([52.20290953911077, 6.552160456370483])
            .setIcon(icon)
            .addTo(map)
            .bindPopup('Deepshof Diepenheim');

        let controls_layer = L.control.layers({
            osm: osm.addTo(map),
            google: L.tileLayer('https://www.google.cn/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}', {
                attribution: 'google'
            })
        }).addTo(map);

        map.removeControl(controls_layer);
    }

    scrollIntoView() {
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                const targetId = this.getAttribute('href').slice(1); // remove the #

                const target = document.getElementById(targetId);

                if (target) {
                    e.preventDefault();

                    target.scrollIntoView({
                        behavior: 'smooth'
                    });
                }
            });
        });
    }

    fontSizeControls() {
        const controls = document.querySelectorAll('.main-navbar__font-size-control');

        const defaultSize = 16;
        const minSize     = 12;
        const maxSize     = 25;

        let currentSize = parseInt(localStorage.getItem('fontsize')) || defaultSize;

        // Apply initial font size
        applyFontSize(currentSize);

        controls.forEach(control => {
            control.addEventListener('click', () => {
                const action = control.dataset.action;

                if (action === 'decrease' && currentSize > minSize) {
                    currentSize--;
                }
                else if (action === 'increase' && currentSize < maxSize) {
                    currentSize++;
                }
                else if (action === 'reset') {
                    currentSize = defaultSize;
                }

                applyFontSize(currentSize);
            });
        });

        function applyFontSize(size) {
            document.documentElement.style.fontSize = `${size}px`;

            localStorage.setItem('fontsize', size);

            // Update button states
            controls.forEach(control => {
                const action = control.dataset.action;

                control.classList.remove('disabled');

                if (action === 'decrease' && size <= minSize) {
                    control.classList.add('disabled');
                }

                if (action === 'increase' && size >= maxSize) {
                    control.classList.add('disabled');
                }
            });
        }
    }
}

function setupVideoPreview(video) {
    let previewSet = false;

    const setPreview = () => {
        if (previewSet) {
            return;
        }

        previewSet = true;

        video.pause();
        video.currentTime = Math.max(0, video.duration - 1);
    };

    // Set preview frame
    if (video.readyState >= 1 && isFinite(video.duration) && video.duration > 0) {
        setPreview();
    }
    else {
        // Wait for metadata to load
        video.addEventListener('loadedmetadata', setPreview, {
            once: true
        });
    }

    // Reset to start when user presses play
    video.addEventListener('play', () => {
        // Only reset if we're still at the preview position
        if (video.currentTime > video.duration - 1.1) {
            video.currentTime = 0;
        }
    });
}

window.addEventListener('load', () => new App());

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('video').forEach(setupVideoPreview);
});
